// ui
import {
  Typography,
  Box,
  Alert,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { PoButton } from "./common/PoButton";
import { PoModalShell } from "./common/PoModalShell";

interface GetXLSXTossUpModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
  };
  setGetXLSXStatus: (getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
  }) => void;
  getXLSXFunc: () => void;
  totalCount: number;
}

export function GetXLSXTossUpModal(props: GetXLSXTossUpModalProps) {
  const {
    onModal,
    swCloseModal,
    getXLSXStatus,
    setGetXLSXStatus,
    getXLSXFunc,
    totalCount,
  } = props;

  const footerNode =
    getXLSXStatus.status === "open" ? (
      <>
        <PoButton
          data-testid="xlsx-tossup-cancel-button"
          variant="secondary"
          onClick={swCloseModal}
        >
          <Box>キャンセル</Box>
        </PoButton>
        <PoButton
          data-testid="xlsx-tossup-download-button"
          variant="primary"
          disabled={totalCount === 0}
          onClick={() => {
            getXLSXFunc();
            setGetXLSXStatus({
              ...getXLSXStatus,
              status: "loading",
            });
          }}
        >
          <Box>出力</Box>
          <FileDownloadIcon sx={{ marginLeft: "6px" }} fontSize="medium" />
        </PoButton>
      </>
    ) : getXLSXStatus.status === "error" ? (
      <PoButton
        data-testid="xlsx-tossup-error-retry-button"
        variant="secondary"
        onClick={() =>
          setGetXLSXStatus({
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : getXLSXStatus.status === "result" ? (
      <PoButton
        data-testid="xlsx-tossup-close-button"
        variant="primary"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : undefined;

  return (
    <PoModalShell
      open={onModal}
      title="トスアップ一覧出力"
      onClose={swCloseModal}
      width="w560"
      testidPrefix="xlsx-tossup"
      frameTestId="xlsx-tossup-modal"
      footer={footerNode}
    >
      {getXLSXStatus.status === "open" ? (
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
          <Box className="info-alert" data-testid="xlsx-tossup-info-alert">
            <Box component="span" className="ia-ic">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <circle cx="12" cy="12" r="9"/>
                <path d="M12 8h.01M12 12v4"/>
              </svg>
            </Box>
            <Box component="span">
              現在の検索条件に一致する <b>{totalCount}件</b> のトスアップを出力します。
            </Box>
          </Box>
        </Typography>
      ) : getXLSXStatus.status === "loading" ? (
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "var(--sp-2)",
            }}
          >
            {/* cmd-po_1248: 待ち表示スピナー。span.po-spinnerはinline=親flex化で32x32を効かせる(先例 Dashboard.tsx:269) */}
            <span className="po-spinner" data-testid="xlsx-loading-spinner" />
            <Box sx={{ textAlign: "center" }}>トスアップ一覧作成準備中</Box>
          </Box>
        </Typography>
      ) : getXLSXStatus.status === "getting" ? (
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "var(--sp-2)",
            }}
          >
            {/* cmd-po_1248: 待ち表示スピナー。span.po-spinnerはinline=親flex化で32x32を効かせる(先例 Dashboard.tsx:269) */}
            <span className="po-spinner" data-testid="xlsx-loading-spinner" />
            <Box sx={{ textAlign: "center" }}>{getXLSXStatus.message}</Box>
          </Box>
        </Typography>
      ) : getXLSXStatus.status === "error" ? (
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
          <Alert severity="error">
            <Box>{getXLSXStatus.message || "トスアップ一覧出力に失敗しました。"}</Box>
          </Alert>
        </Typography>
      ) : getXLSXStatus.status === "result" ? (
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
          <div className="result-state -success">
            <span className="rs-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span className="rs-title">出力が完了しました</span>
            <span className="rs-desc">Excelファイルのダウンロードを開始しました。ブラウザのダウンロード先をご確認ください。</span>
          </div>
        </Typography>
      ) : null}
    </PoModalShell>
  );
}
